import CRMTripManagement from "../Trips";

export default function CRMDisneyland() {
  return <CRMTripManagement destination="disneyland" />;
}
